<template>
  <el-dialog v-model="dialogVisible" title="模板参照" @opened="opened" width="70%" top="5vh">
    <div class="list">
      <div class="list-filter">
        <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
          <el-form-item label="编码">
            <el-input size="medium" v-model="queryEntity.code" placeholder="编码"></el-input>
          </el-form-item>
          <el-form-item label="名称">
            <el-input size="medium" v-model="queryEntity.name" placeholder="名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
            <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="list-table">
        <el-table :data="dataList" :header-cell-class-name="headerCellClass" :max-height="400" border size="medium" highlight-current-row @current-change="changeCurrentRow">
          <el-table-column prop="no" label="序号" width="50" fixed> </el-table-column>
          <el-table-column prop="code" label="编码" width="200" fixed> </el-table-column>
          <el-table-column prop="name" label="名称" width="200" fixed> </el-table-column>
          <el-table-column prop="path" label="路径" width="300"> </el-table-column>
          <el-table-column prop="typeName" label="类型" width="100"> </el-table-column>
          <el-table-column prop="client" label="客户端" width="100">
            <template #default="scope">
              <div class="column-tag">
                <el-tag v-if="scope.row.client=='mobile'" type="danger" size="mini">手机</el-tag>
                <el-tag v-else size="mini">电脑</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>
      </div>
      <div class="list-pager">
        <el-pagination class="list-pager-inner" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" v-model:currentPage="queryParam.pager.pageIndex" v-model:page-size="queryParam.pager.pageSize" :total="queryParam.pager.total" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button ref="btnConfirm" type="primary" @click="confirm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import {
  Category,
  Content,
  Template,
} from "@/script/apps/cms/entity/CmsEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CallBack } from "@/script/core/service/DataService";
import { TemplateService } from "@/script/apps/cms/service/TemplateService";
import { DictUtil } from "@/script/core/Dict";

@Options({})
export default class TemplateRefer extends BaseList {
  private queryEntity: Template = {};
  private dataList: Template[] = [];
  private service = new TemplateService();

  private dialogVisible = false;
  private currentRow: Template | null = null;
  private callBack: CallBack<Template> | null = null;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_template",
      "/cms/template",
      "/cms/template",
      this.service
    );
    data.typesName = "template-type";
    return data;
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const currDataList: Template[] = data.list as Template[];
    currDataList.forEach((item) => {
      item.typeName = DictUtil.getItemName(this.types, item.type);
    });
    this.dataList = currDataList;
  }

  changeCurrentRow(row: Template) {
    this.currentRow = row;
  }

  public show(callBack: CallBack<Template>) {
    this.currentRow = null;
    this.callBack = callBack;
    this.dialogVisible = true;
  }

  confirm() {
    if (this.currentRow === null) {
      ElMessage.error("请选择模板！");
      return;
    }
    this.dialogVisible = false;
    if (this.callBack) {
      this.callBack(this.currentRow!);
    }
  }
}
</script>
